import React from "react";
import { FaShareFromSquare } from "react-icons/fa6";

// Images
import blogImg1 from "../BlogCardSection/images/blogCard_Img1.png";
import blogImg2 from "../BlogCardSection/images/blogCard_Img2.png";
import blogImg3 from "../BlogCardSection/images/blogCard_Img3.png";
import blogImg4 from "../BlogCardSection/images/blogCard_Img4.png";
import blogImg5 from "../BlogCardSection/images/blogCard_Img5.png";
import blogImg6 from "../BlogCardSection/images/blogCard_Img1.png";
import blogImg7 from "../BlogCardSection/images/blogCard_Img1.png";
import blogImg8 from "../BlogCardSection/images/blogCard_Img1.png";

/* ---- content per card ---- */
const CARDS = [
    {
        img: blogImg1,
        title: "Police Departments Register Complaints via WhatsApp- Simple Guide",
        tags: ["Remote Work", "Webinar"]
    },
    {
        img: blogImg2,
        title: "Transform Car Dealerships with WhatsApp API",
        tags: ["Agile Practices", "Teamwork"]
    },
    {
        img: blogImg3,
        title: "WhatsApp Business API vs. Google & Facebook Ads for Data Insights",
        tags: ["Productivity", "Webinar"]
    },
    {
        img: blogImg4,
        title: "Hidden struggles in higher education can be solved by WhatsApp API",
        tags: ["Leadership", "Webinar"]
    },
    {
        img: blogImg5,
        title: "WhatsApp Business API: Hassle-Free Hospital Appointments & Services",
        tags: ["Quick Tips", "Agile Practices"]
    },
    {
        img: blogImg6,
        title: "Fixing Key Education Gaps in India with WhatsApp API",
        tags: ["Communication", "Webinar"]
    },
    {
        img: blogImg7,
        title: "Public Scheme Awareness Campaigns with WhatsApp",
        tags: ["Agile", "Webinar"]
    },
    {
        img: blogImg8,
        title: "Simplify Logistics with WhatsApp: Smarter, Faster, Better",
        tags: ["Collaboration", "Webinar"]
    },
];

const BlogCardSection = () => {
    return (
        <section className="py-5 position-relative" style={{ overflow: "hidden" }}>
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{ maxWidth: "74%", zIndex: 1 }}
            >
                {/* Heading */}
                <div style={{ marginTop: 10 }}>
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Our latest articles
                    </h2>

                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Discover helpful blogs from Vertex Suite. Learn about smart ways to use WhatsApp, automate tasks
                        and improve communication- all shared in a simple, practical way to support your growth and everyday business needs.
                    </p>
                </div>

                {/* ---- Auto-scrolling ---- */}
                <div
                    style={{
                        marginTop: "2.5rem",
                        position: "relative",
                        overflow: "hidden",
                        width: "100%",
                        maskImage:
                            "linear-gradient(to right, rgba(0,0,0,0) 0, rgba(0,0,0,.85) 16px, rgba(0,0,0,.85) calc(100% - 16px), rgba(0,0,0,0) 100%)",
                        WebkitMaskImage:
                            "linear-gradient(to right, rgba(0,0,0,0) 0, rgba(0,0,0,.85) 16px, rgba(0,0,0,.85) calc(100% - 16px), rgba(0,0,0,0) 100%)",
                    }}
                >
                    {/* add  animation runs */}
                    <div className="blog-track" style={trackStyle}>
                        {CARDS.map((c, i) => (
                            <Card key={`a-${i}`} {...c} />
                        ))}
                        {CARDS.map((c, i) => (
                            <Card key={`b-${i}`} {...c} />
                        ))}
                    </div>
                </div>
            </div>

            {/* Animation */}
            <style>{scrollCSS}</style>
        </section>
    );
};

/* ---------- Card with image + content ---------- */
const Card = ({ img, title, tags }) => (
    <div style={cardStyle}>
        {/* Image */}
        <div style={imgWrapStyle}>
            <img src={img} alt="" style={imgStyle} />
        </div>

        {/* Content */}
        <div style={{ padding: "12px 14px 16px" }}>
            {/* Title (2-line clamp for neat rows) */}
            <h3
                style={{
                    margin: 0,
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#2c3e50",
                    lineHeight: 1.35,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                }}
                title={title}
            >
                {title}
            </h3>

            {/* Tags */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
                {tags?.map((t, idx) => (
                    <span
                        key={idx}
                        style={{
                            fontSize: 12,
                            color: "#6B6B6B",
                            background: "#f4f8fdff",
                            borderRadius: "8px",
                            padding: "6px 10px",
                            lineHeight: 1,
                            border: "1px solid #eef2f9ff",
                        }}
                    >
                        {t}
                    </span>
                ))}
            </div>

            {/* Footer row */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 12,
                    marginLeft: "4px",
                }}
            >
                {/* Read more */}
                <a
                    href="#"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: 14,
                        fontWeight: 600,
                        color: "#054E91",
                        textDecoration: "none",
                    }}
                >
                    Read More <span aria-hidden>➜</span>
                </a>

                {/* Share icon */}
                <FaShareFromSquare
                    size={18}
                    color="#054E91"
                    style={{ cursor: "pointer" }}
                    title="Share"
                />
            </div>
        </div>
    </div>
);

/* ---------- Styles ---------- */
const cardStyle = {
    flex: "0 0 auto",
    width: 360,                 
    borderRadius: 14,
    background: "#FFFFFF",
    boxShadow: "0 10px 24px rgba(16,24,40,0.06)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
};

const imgWrapStyle = {
    width: "100%",
    background: "#F3F4F6",
};

const imgStyle = {
    display: "block",
    width: "100%",
    height: "auto",           
    objectFit: "contain",     
    background: "#F3F4F6",
};

const trackStyle = {
    display: "inline-flex",
    alignItems: "stretch",
    gap: 18,
    whiteSpace: "nowrap",
    willChange: "transform",
};

/* Animation */
const scrollCSS = `
@keyframes scrollRightInfinite { 
  0%   { transform: translateX(0); } 
  100% { transform: translateX(-50%); } 
}

/* make the track actually animate */
.blog-track {
  animation: scrollRightInfinite 28s linear infinite;
}
.blog-track:hover { animation-play-state: paused; }

/* smoothness on low-power devices */
@media (prefers-reduced-motion: reduce) {
  .blog-track { animation: none; }
}
`;

export default BlogCardSection;
